import React from 'react';

import Header from '../presentational/Header';

const HeaderContainer = () => {
    return <Header />;
};

export default HeaderContainer;
